import { render, staticRenderFns } from "./oaWorkflowManageList.vue?vue&type=template&id=20e2008e&scoped=true"
import script from "./oaWorkflowManageList.vue?vue&type=script&lang=js"
export * from "./oaWorkflowManageList.vue?vue&type=script&lang=js"
import style0 from "./oaWorkflowManageList.vue?vue&type=style&index=0&id=20e2008e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2008e",
  null
  
)

export default component.exports